import { render, staticRenderFns } from "./NewsItem.vue?vue&type=template&id=ecf13044"
import script from "./NewsItem.vue?vue&type=script&lang=js"
export * from "./NewsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ImageLoading: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/ImageLoading.vue').default})
